import api from 'src/utils/ajax';

import { denormalizeTask, normalizeTask } from './normalizers';

/** @typedef { import('./_types').Task } Task */

/**
 * @typedef { object } FetchTaskOptions
 * @prop { Task['id'][] } [ids]
 * @prop { number } [page]
 * @prop { number } [per]
 * @prop { boolean } [fetchAll]
 */
/** @type {(options?: FetchTaskOptions) => Promise<{tasks: Task[], total: number}>} */
export const fetchTasks = async (options) => {
  const { ids, page, per, fetchAll } = options || {};
  const params = {
    with_ids: ids?.join(','),
    page,
    per,
    fetch_all: fetchAll,
  };

  const response = await api.get(`/api/v4/clock/tasks`, {
    params: params,
  });

  const tasks = response.data?.task
    ? response.data.task.map((task) => normalizeTask(task))
    : response.data.map((task) => normalizeTask(task));

  if (ids?.length) {
    return tasks;
  }

  return {
    tasks,
    total: response.data?.meta?.total || tasks.length,
  };
};

/** @type {(task: Task) => Promise<Task>} */
export const createTask = async (task) => {
  const response = await api.post(`/api/v4/clock/tasks`, denormalizeTask(task));
  return normalizeTask(response.data);
};

/** @type {(task: Task) => Promise<Task>} */
export const updateTask = async (task) => {
  const response = await api.put(
    `/api/v4/clock/tasks/${task.id}`,
    denormalizeTask(task)
  );
  return normalizeTask(response.data);
};

/** @type {(task: Partial<Task>) => Promise<Task>} */
export const deleteTask = async (task) => {
  const response = await api.delete(`/api/v4/clock/tasks/${task.id}`);
  return normalizeTask(response.data);
};
